namespace advisorop.components.widgets {
    
    export class GaugeAllocationCoreAlternativeController{
        chartData: Array<domains.IChartDataSource>;
        asOfDate;
        alternativeValue;
        coreValue;
        rtgName: string;    
        gauge;

        getSegmentColors(): any {

            var colors = [
                {
                    "code": "#63af33",
                    "minValue": "0",
                    "maxValue": this.coreValue,
                    "label": "Core",
                },
                {
                    "code": "#d4efc3",
                    "minValue": this.coreValue,
                    "maxValue": "100",
                    "label": "Alternative",
                }];
            return colors;      
        }

        updateGauge() {

            var pointer = {
                "bgColor": "#0c9b43",
                "radius": "10",
                "sides": "3",
                "value": this.coreValue,
                "displayValue": "{br}Portfolio is {br}" + this.coreValue + "% core assets."
            };
            //setting points

            /*
            green #63af33
            orange #ffa500
            red #cc0000

            */
            this.gauge = {
                "chart": {
                    "theme": "fint",
                    "baseFontSize":"14",
                    //"caption": "Portfolio Equity Allocation",
                    //"subcaption": "RTG: " + this.rtgName,
                    "lowerLimit": "0",
                    "upperLimit": "100",
                    "numberSuffix": "%",
                    "chartBottomMargin": "40",
                    "valueFontSize": "13",
                    "valueFontBold": "0",
                    "valueAbovePointer": "0",
                    "gaugeFillMix": "{light-10},{light-70},{dark-10}",
                    "gaugeFillRatio": "40,20,40",
                    "showTickMarks": "0",
                    "showTickValues": "0",
                    "pointerOnTop": "0"
                },
                "colorRange": {
                    "color": this.getSegmentColors()
                },
                "pointers": {
                    "pointer": [pointer]
                },
                "trendPoints": {
                    "point": [
                        //Adding Trendpoint
                        {
                            "startValue": "0",
                            "color": "#a0a0a0",
                            "dashed": "0",
                            "thickness": "2"
                        }, {
                            "startValue": "25",
                            "color": "#a0a0a0",
                            "dashed": "0",
                            "thickness": "2"
                        }, {
                            "startValue": "50",
                            "color": "#a0a0a0",
                            "dashed": "0",
                            "thickness": "2"
                        }, {
                            "startValue": "75",
                            "color": "#a0a0a0",
                            "dashed": "0",
                            "thickness": "2"
                        }, {
                            "startValue": this.coreValue,
                            "dashed": "1",
                            "thickness": "1",
                            "displayValue": " "
                        }
                    ]
                }
            };
        };    

        
        constructor(private advisorService: services.AdvisorService) {
                                
        }
      

        $onChanges(evt) {
            for (var key in evt) {
                if (key === "alternativeValue" && this.alternativeValue >= 0) {
                    //console.log("Updating gauge to:" + this.alternativeValue);
                    this.coreValue = Math.round((100 - this.alternativeValue) * 100) / 100;
                    this.updateGauge();
                }
            }
        }

        $onInit(): void {
            if (this.alternativeValue == undefined) {
                this.alternativeValue = 0;
            }
            this.updateGauge();            
        }

        $routerOnActivate(next, previous) {
            
        }        

    }



    class GaugeAllocationCoreAlternative implements ng.IComponentOptions {

        public bindings: any;
        public controller: any;
        public controllerAs: string;
        public templateUrl: string;
        
        constructor() {
            this.bindings = {
                alternativeValue: "<",
                rtgName: "<"
            };
            this.controller = ["advisorService", GaugeAllocationCoreAlternativeController];
            this.controllerAs = "vm";
            this.templateUrl = 'spa/advisor-module/components/gauge-allocation-core-alternative.html';            
        }
    }
    angular.module(Constants.APP).component("gaugeAllocationCoreAlternative", new GaugeAllocationCoreAlternative());
    
}